import { BridgeBase } from './bridge-base';
import { OutboundMessage } from '../internal-types';

const TAG = '[Dashboard SDK]';

export class Bridge extends BridgeBase {

  protected postMessage: (msg: OutboundMessage) => void;

  constructor(private window: Window) {
    super(window);
    window.addEventListener('message', this.receiveMessage.bind(this), false);
    this.postMessage = (msg) => window.parent.postMessage(JSON.stringify(msg), '*');
    console.log(`${TAG} Creating Dashboard SDK`);
  }

  setWindowEventHandler(eventName: string, handler: (event: Event) => void): void {
    this.window.addEventListener(eventName, handler);
  }
}
